import './clickable-icon-with-legend.scss'

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const ClickableIconWithLegend = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./clickable-icon-with-legend.html'),
    props: ['icon', 'legendKey', 'dataCy'],
})
